/** compareValues can be used on scenarios for sorting an object array based on a given property and the order(asc or desc)
 * let arr = [{prop1: prop1value1, prop2: prop1value2}, {prop1: prop2value1, prop2: prop2value2}]
 * arr.sort(compare("prop1","asc")); will sort the array be prop1 in ascending order
 */
export function compareValues(key, order = "asc") {
  return function innerSort(a, b) {
    if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
      // property doesn't exist on either object
      return 0;
    }

    const varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
    const varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

    let comparison = 0;
    if (varA > varB) {
      comparison = 1;
    } else if (varA < varB) {
      comparison = -1;
    }
    return order === "desc" ? comparison * -1 : comparison;
  };
}
export function debounce(fn, delay) {
  var timeoutID = null;
  return function () {
    clearTimeout(timeoutID);
    var args = arguments;
    var that = this;
    timeoutID = setTimeout(function () {
      fn.apply(that, args);
    }, delay);
  };
}

export function groupByAndSum(data, groupByProperties, sumProperty) {
  // Group and sum by the specified properties
  const groupedResult = data.reduce((acc, item) => {
    // Create a unique key by concatenating the group properties
    const groupKey = groupByProperties.map((prop) => item[prop]).join("|");

    // If the group key is not yet in the accumulator, add it with initial value 0
    if (!acc[groupKey]) {
      acc[groupKey] = 0;
    }

    // Add the sum value to the accumulator
    acc[groupKey] += item[sumProperty];

    return acc;
  }, {});

  // Parse the result into a more structured format
  return Object.entries(groupedResult).map(([key, value]) => {
    const groupValues = key.split("|");
    const resultObject = { [sumProperty]: value };

    groupByProperties.forEach((prop, index) => {
      resultObject[prop] = groupValues[index];
    });

    return resultObject;
  });
}

export function sortByPalletID(arr) {
  if (!Array.isArray(arr)) return;
  arr.sort((a, b) => {
    const aId = a.PalletID;
    const bId = b.PalletID;
    if (!isNaN(aId) && !isNaN(bId)) {
      return Number(aId) - Number(bId);
    }
    return String(aId).localeCompare(String(bId));
  });
}
